import * as AbsintheSocket from '@absinthe/socket';
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link';
import { ApolloLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { createLink } from 'apollo-absinthe-upload-link';
import SocketWithBackoffReconnect from '../../utils/SocketWithBackoffReconnect';

const authToken = localStorage.getItem('authToken');

const socket = new SocketWithBackoffReconnect('/graphql', {
  authToken,
});

const abortController = new AbortController();

// Needed by LogRocket https://docs.logrocket.com/docs/graphql#apollo-client-with-graphql
const fetcher = (...args: Parameters<Window['fetch']>) => {
  return window.fetch(...args);
};

// We need to pass `fetch`, otherwise `apollo-absinthe-upload-link` will
// assume that `fetch` is not available and use `rxjs`'s `Observable`.
// See https://github.com/bytewitchcraft/apollo-absinthe-upload-link/issues/18
const httpLink = createLink({
  fetch: fetcher,
  fetchOptions: { signal: abortController.signal },
  uri: '/graphql',
});

const subscriptionLink = createAbsintheSocketLink(
  AbsintheSocket.create(socket),
);

export default ApolloLink.split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return (
      def.kind === 'OperationDefinition' && def.operation === 'subscription'
    );
  },
  // @ts-expect-error
  subscriptionLink,
  httpLink,
);
